import { UsdcChains } from "../../types/types";
import { capitalizeWords } from "../../utils/helper";

const SelectUsdcNetwork = ({
  name,
  icon,
  state,
  setState,
}: {
  name: UsdcChains;
  icon: string;
  state: UsdcChains | undefined;
  setState: (network: UsdcChains) => void;
}) => {
  return (
    <div
      className={`rounded-[8px] max-md:h-[50px]  h-[100px] flex-1 border-[1px] border-grey cursor-pointer flex flex-col max-md:flex-row items-center justify-center gap-2 transition-all ${state === name ? "border-brand-darkYellow border-[2px]" : "opacity-[0.5] "} hover:opacity-[0.7]`}
      onClick={() => {
        setState(name);
      }}
    >
      <img src={icon} className="max-md:w-[20px] max-md:h-[20px] w-[30px]" />
      <p className="max-md:text-[14px] text-[16px] text-black font-[500]">
        {capitalizeWords(name)}
      </p>
    </div>
  );
};

export default SelectUsdcNetwork;
